import logo from "../assets/images/tree-logo.svg";
import t from "../locales";

export default function Footer() {
  return (
    <footer className="footer">
      <img className="footer__logo" src={logo} alt={t("general.logo-alt")} />
    </footer>
  );
}
